/* ============================================================
   AMBITIOUS 99 — Storefront V3
   Carrito nativo de Shopify (Ajax API + Section Rendering API).
   NO contiene: enlaces a mensajeria externa, codigo manual de pixel,
   precios calculados en el cliente ni checkout propio.
   Shopify es la unica fuente de verdad del precio y de la orden.
   ============================================================ */
(function () {
  'use strict';

  var R = window.AMB || {};
  var routes = R.routes || {};
  var CART_ADD = (routes.cart_add || '/cart/add') + '.js';
  var CART_CHANGE = (routes.cart_change || '/cart/change') + '.js';
  var CART_URL = (routes.cart || '/cart') + '.js';
  var DRAWER_SECTION = 'ambitious-cart-drawer';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------- Drawer ---------------- */
  var lastFocus = null;

  function drawer() { return $('[data-amb-drawer]'); }
  function backdrop() { return $('[data-amb-backdrop]'); }

  function openDrawer() {
    var d = drawer(); if (!d) { window.location.href = routes.cart || '/cart'; return; }
    lastFocus = document.activeElement;
    d.setAttribute('data-open', 'true');
    d.removeAttribute('aria-hidden');
    if (backdrop()) backdrop().hidden = false;
    document.documentElement.classList.add('amb-no-scroll');
    startTimer();
    var close = $('[data-amb-drawer-close]', d);
    if (close) close.focus();
    document.addEventListener('keydown', onEsc);
  }

  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.setAttribute('data-open', 'false');
    d.setAttribute('aria-hidden', 'true');
    if (backdrop()) backdrop().hidden = true;
    document.documentElement.classList.remove('amb-no-scroll');
    document.removeEventListener('keydown', onEsc);
    if (timerId) { clearInterval(timerId); timerId = null; }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onEsc(e) { if (e.key === 'Escape') closeDrawer(); }

  /* ---------------- Render del drawer ---------------- */
  function paintSections(sections) {
    if (!sections) return;
    var html = sections[DRAWER_SECTION];
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-amb-drawer-root]');
    var current = $('[data-amb-drawer-root]');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      startTimer();
    }
  }

  function paintCount(n) {
    $$('[data-amb-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = false;
    });
  }

  function refreshCart() {
    return fetch(CART_URL + '?t=' + Date.now(), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCount(cart.item_count); return cart; });
  }

  /* ---------------- Agregar al carrito ---------------- */
  function addToCart(form) {
    var btn = $('[data-amb-submit]', form);
    var err = $('[data-amb-error]', form);
    var body = new FormData(form);

    // La cantidad se fija explícitamente. Si el input existe, su valor manda:
    // así no depende de cómo el navegador serialice el campo numérico.
    var qtyInput = form.querySelector('[name="quantity"]');
    if (qtyInput) {
      var q = parseInt(qtyInput.value, 10);
      if (isNaN(q) || q < 1) q = 1;
      body.set('quantity', String(q));
    }

    body.append('sections', DRAWER_SECTION);

    if (err) err.textContent = '';
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }

    return fetch(CART_ADD, { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          // Shopify devuelve description cuando no hay inventario suficiente.
          var msg = res.data && (res.data.description || res.data.message) || 'No se pudo agregar. Revisá la talla y el color.';
          if (err) err.textContent = msg;
          return;
        }
        paintSections(res.data.sections);
        return refreshCart().then(function () {
          confirmOn(btn);
          openDrawer();
        });
      })
      .catch(function () {
        if (err) err.textContent = 'Falló la conexión. Intentá de nuevo.';
      })
      .then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      });
  }

  function confirmOn(btn) {
    if (!btn) return;
    var original = btn.innerHTML;
    btn.innerHTML = 'Agregado';
    btn.classList.add('is-done');
    setTimeout(function () { btn.innerHTML = original; btn.classList.remove('is-done'); }, 1500);
  }

  /* ---------------- Cambiar cantidad / eliminar ---------------- */
  function changeLine(key, quantity) {
    var root = $('[data-amb-drawer-root]');
    if (root) root.classList.add('amb-busy');
    return fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: DRAWER_SECTION })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        paintSections(data.sections);
        paintCount(data.item_count);
      })
      .catch(function () { window.location.reload(); })
      .then(function () {
        var r2 = $('[data-amb-drawer-root]');
        if (r2) r2.classList.remove('amb-busy');
      });
  }


  /* ---------------- Temporizador (solo visual) ----------------
     No reserva stock, no cambia precios, no vacia la cesta.
     Al llegar a cero simplemente se queda en 00:00.                */
  var timerId = null;

  function startTimer() {
    if (timerId) { clearInterval(timerId); timerId = null; }
    var el = $('[data-amb-timer]');
    if (!el) return;
    var mins = parseInt(el.dataset.minutes, 10);
    if (!mins || mins < 1) mins = 10;
    var left = mins * 60;

    function tick() {
      var m = Math.floor(left / 60), sec = left % 60;
      el.textContent = m + ':' + (sec < 10 ? '0' : '') + sec;
      if (left <= 0) { clearInterval(timerId); timerId = null; return; }
      left--;
    }
    tick();
    timerId = setInterval(tick, 1000);
  }

  /* ---------------- Selector de variante ---------------- */
  function variantData(root) {
    var tag = $('[data-amb-variants]', root);
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  function syncVariant(root) {
    var variants = variantData(root);
    if (!variants) return;
    // Dos formas de elegir variante: <select> en las cards, pills en el PDP.
    var groups = $$('[data-amb-optgroup]', root);
    var selects = $$('[data-amb-option]', root);
    var chosen;

    if (groups.length) {
      chosen = groups.map(function (g) {
        var checked = g.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      });
    } else if (selects.length) {
      chosen = selects.map(function (s) { return s.value; });
    } else {
      return;
    }
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < chosen.length; j++) {
        if (String(v.options[j]) !== String(chosen[j])) { ok = false; break; }
      }
      if (ok) { match = v; break; }
    }

    var idInput = $('[data-amb-variant-id]', root);
    var btn = $('[data-amb-submit]', root);
    var priceEl = $('[data-amb-price]', root);
    var compareEl = $('[data-amb-compare]', root);
    var err = $('[data-amb-error]', root);

    if (!match) {
      if (btn) { btn.disabled = true; btn.textContent = 'Combinación no disponible'; }
      if (err) err.textContent = '';
      return;
    }

    if (idInput) idInput.value = match.id;
    if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
    if (compareEl) {
      compareEl.innerHTML = match.compare_html || '';
      compareEl.hidden = !match.compare_html;
    }

    // Ahorro de la caja de promo: también sale de Shopify, no se calcula acá.
    var saveEl = $('[data-amb-save]', root);
    if (saveEl) {
      if (match.save_html) {
        saveEl.textContent = (saveEl.dataset.ambSaveLabel || 'Ahorrás') + ' ' + match.save_html;
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }
    if (btn) {
      btn.disabled = !match.available;
      btn.textContent = match.available ? (btn.dataset.labelAdd || 'Agregar al carrito') : 'Agotado';
    }
    if (err) err.textContent = '';

    // Mantiene la URL del PDP alineada con la variante elegida (deep-link desde anuncios).
    if (root.hasAttribute('data-amb-update-url')) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', u.toString());
    }
  }


  /* ---------------- Cards a color al hacer scroll (táctil) ----------------
     En pantalla táctil no hay hover útil, así que la card sale del blanco y
     negro cuando entra en la franja central de la pantalla y vuelve al salir.
     En escritorio con mouse no se toca nada: manda el :hover del CSS.        */
  var cardObserver = null;

  function isTouch() {
    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }

  function watchCards() {
    if (!isTouch()) return;

    if (!('IntersectionObserver' in window)) {
      document.documentElement.classList.add('amb-no-io');
      return;
    }

    if (!cardObserver) {
      cardObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-inview', entry.isIntersecting);
        });
      }, {
        // Zona activa: el 40% central del alto de la pantalla.
        rootMargin: '-30% 0px -30% 0px',
        threshold: 0
      });
    }

    $$('.amb-card--gray').forEach(function (card) {
      if (card.dataset.ambWatched) return;
      card.dataset.ambWatched = '1';
      cardObserver.observe(card);
    });
  }


  /* ---------------- Corte de envío ----------------
     Cuenta hasta la hora de corte del reloj del visitante. Es informativo:
     no reserva stock, no cambia precios y no bloquea la compra.        */
  function startCutoff() {
    var el = $('[data-amb-cutoff]');
    if (!el) return;
    var out = $('[data-amb-cutoff-text]', el);
    if (!out) return;

    var hour = parseInt(el.dataset.ambCutoff, 10);
    if (isNaN(hour)) return;

    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, 0, 0);
      if (end <= now) { el.hidden = true; return; }

      var left = Math.floor((end - now) / 1000);
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var sec = left % 60;
      out.textContent = ' ' + (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
    }
    tick();
    setInterval(tick, 1000);
  }


  /* ---------------- Cantidad (+ / −) ---------------- */
  function stepQty(btn) {
    var box = btn.closest('.amb-qtybox');
    if (!box) return;
    var input = box.querySelector('[data-amb-qtyinput]');
    if (!input) return;
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 1;
    var next = current + parseInt(btn.dataset.ambQtystep, 10);
    if (next < 1) next = 1;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }


  /* ---------------- Barra de compra al hacer scroll ----------------
     Se muestra cuando el botón principal deja de verse y se esconde
     cuando vuelve. No agrega lógica de compra: envía el mismo form.  */
  function watchStickyBuy() {
    var bar = $('[data-amb-stickybuy]');
    if (!bar) return;
    var main = $('.amb-pdp__buy [data-amb-submit]');
    if (!main) return;

    if (!('IntersectionObserver' in window)) { bar.dataset.show = 'true'; return; }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.dataset.show = entry.isIntersecting ? 'false' : 'true';
      });
    }, { rootMargin: '0px 0px -80px 0px', threshold: 0 }).observe(main);
  }

  /* ---------------- Menu movil ---------------- */
  function toggleNav(open) {
    var nav = $('[data-amb-mobilenav]');
    if (!nav) return;
    nav.setAttribute('data-open', open ? 'true' : 'false');
    document.documentElement.classList.toggle('amb-no-scroll', open);
  }

  /* ---------------- Galeria PDP ---------------- */
  function pickImage(btn) {
    var root = btn.closest('[data-amb-gallery]');
    if (!root) return;
    var main = $('[data-amb-gallery-main]', root);
    if (main) {
      main.src = btn.dataset.full;
      main.srcset = btn.dataset.srcset || '';
      main.alt = btn.dataset.alt || main.alt;
    }
    $$('[data-amb-gallery-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', String(t === btn)); });
  }

  /* ---------------- Delegacion de eventos ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-amb-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-amb-drawer-close]') || t.closest('[data-amb-backdrop]')) { e.preventDefault(); closeDrawer(); return; }
    if (t.closest('[data-amb-nav-open]')) { e.preventDefault(); toggleNav(true); return; }
    if (t.closest('[data-amb-nav-close]')) { e.preventDefault(); toggleNav(false); return; }

    var step = t.closest('[data-amb-qtystep]');
    if (step) { e.preventDefault(); stepQty(step); return; }

    var qty = t.closest('[data-amb-qty]');
    if (qty) {
      e.preventDefault();
      changeLine(qty.dataset.key, parseInt(qty.dataset.qty, 10));
      return;
    }

    var thumb = t.closest('[data-amb-gallery-thumb]');
    if (thumb) { e.preventDefault(); pickImage(thumb); return; }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-amb-option]') || e.target.closest('[data-amb-optgroup]');
    if (!sel) return;
    var root = sel.closest('[data-amb-product]');
    if (root) syncVariant(root);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-amb-add-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  /* ---------------- Init ---------------- */
  function init() {
    $$('[data-amb-product]').forEach(syncVariant);
    watchCards();
    startCutoff();
    watchStickyBuy();
    // El marquee ya no necesita JS: la pista se duplica en Liquid.
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-inicializa al editar secciones en el Theme Editor.
  document.addEventListener('shopify:section:load', init);

  window.AmbitiousCart = { open: openDrawer, close: closeDrawer, refresh: refreshCart };
})();
